import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiComponentsModule } from '../../../../shared/shared-module-ui/ui-components.module';
import { DEFAULT_LOADER_FLASH, ISharedLoadingG } from '../../../../shared/shared-module-ui/models/animations';

/**
 * Loading modal shown while stock take retry data is being loaded.
 */
@Component({
  selector: 'app-stock-take-retry-loading-modal',
  standalone: true,
  imports: [CommonModule, UiComponentsModule],
  templateUrl: './stock-take-retry-loading-modal.component.html',
  styleUrls: ['./stock-take-retry-loading-modal.component.scss'],
})
export class StockTakeRetryLoadingModalComponent {
  @Input() message: string = 'Loading stock take figures…';

  protected readonly animation: Readonly<ISharedLoadingG> = DEFAULT_LOADER_FLASH;
}
